export default __webpack_public_path__ + "static/media/rs-logo.6ea2d54d.svg";